import React, { useEffect } from 'react';
import { useStaticQuery, graphql } from "gatsby";
import { DateTime } from 'luxon';
import styled from '@emotion/styled';
import * as breakpoint from '../../../styles/breakpoints.module.scss';
import { useLocalization } from 'gatsby-theme-i18n';
import LinkItem from "../../../components/LinkItem"



const UpdateSection = ({ post }) => {
  const data = useStaticQuery(graphql`
    query UpdateQuery {
      allUpdateCsv {
        nodes {
          ...localizedContent
        }
      }
    }
  `);

  const { addString, t } = useLocalization();
  const {fields , slug, frontmatter} = post.childrenMdx[0];
  const PostTime = DateTime.fromFormat(frontmatter.date, 'yyyy.MM.dd');

  useEffect(() => {
    addString('update',data.allUpdateCsv.nodes);
  },[addString, data]);

  if(post)
    return (<SectionWrapper>
      <SectionContent>
        <Label>{t('nav.update.label')}</Label>
        <Post>
          <PostLink fade to={`/${fields.localePath}/update${slug.replace(fields.localePath,'')}`} />
          <Date>{PostTime.toFormat(t('update.article.date.format'))}</Date>
          <Title>{frontmatter.title}</Title>
        </Post>
      </SectionContent>
    </SectionWrapper>);
  else
    return(<></>)
}
 
export default UpdateSection;





const SectionWrapper = styled.div`
  position:relative;
  z-index:10;
`



const SectionContent = styled.div`
  width:100%;
  max-width:928px;
  margin:-128px auto 96px;
  display:flex;

  @media only screen and (max-width: ${breakpoint.smMax}){
    margin:16px 80px 64px;
    width:auto;
    max-width:none;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    margin:6px 24px 0;
    display:block;
  }
`

const Label = styled.div`
  padding: 6px 14px;
  border: 2px solid #D00F31;
  box-sizing: border-box;
  border-radius: 6px;
  color:#D00F31;
  font-weight: 900;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.03em;
  white-space:nowrap;
  margin-right:8px;
  display:inline-block;
  background:#f7f7fa;
  

  @media only screen and (max-width: ${breakpoint.xsMax}){
    padding: 2px 12px;
    font-size: 10px;
    line-height: 16px;
    margin-bottom:8px;
  }
`

const Post = styled.div`
  position:relative;
  background: #FCFCFF;
  width:100%;
  overflow: hidden;
  
  text-overflow: ellipsis;
  padding-right:48px;
/* Shadow / 1dp */

  box-shadow: 0px 2px 2px -2px rgba(0, 0, 0, 0.05), 0px 6px 6px -6px rgba(0, 0, 0, 0.03), 0px 16px 14px -14px rgba(0, 0, 0, 0.03);
  border-radius: 6px;
  white-space:nowrap;
  &:after{
    content:' ';
    position:absolute;
    right:22px;
    top: 50%;
    margin-top:-3px;
    width: 5px;
    height: 5px;
    border-top:1px solid #ADADAF;
    border-right:1px solid #ADADAF;
    transform: matrix(0.71, -0.71, -0.71, -0.71, 0, 0);
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    white-space:normal;
    padding:8px 36px 8px 12px;
  }
`

const PostLink = styled(LinkItem)`
  position:absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
  z-index:2;
`

const Date = styled.div`
  color: #6E6E70;
  font-weight: 900;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.03em;
  padding:8px 16px;
  margin-right:16px;
  position:relative;
  display:inline-block;

  &:after{
    content:' ';
    position:absolute;
    right:0;
    top:10px;
    width: 1px;
    height: 12px;
    background: #CACACD;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    display:none;
  }
`

const Title = styled.div`
  color: #6E6E70;
  font-weight: 900;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.03em;
  position:relative;
  display:inline;
  
  @media only screen and (max-width: ${breakpoint.xsMax}){
    display:block;
    padding:0;
    font-size: 10px;
    line-height: 16px;
  }
  
`
